import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMoveFolder: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconMoveFolder"><Path d="M23.0605 17.25L19.5303 20.7803L18.4697 19.7197L20.1895 18H15V16.5H20.1895L18.4697 14.7803L19.5303 13.7197L23.0605 17.25Z" fill="currentColor"/><Path d="M12.4014 6H22V14.0684L19.5303 11.5986L16.1289 15H13.5V20H2V3H10.4014L12.4014 6Z" fill="currentColor"/></CentralIconBase>;
});

export default IconMoveFolder;
